import React from 'react'
import './breadcrumb.scss'
import { Link } from "react-router-dom";
const Breadcrumb = ({ crumbs }) => {
    return (
        <nav className="breadcrumb">
            {crumbs.map((crumb, index) => (
                <span
                    key={index}
                    className={`breadcrumb-item ${index === crumbs.length - 1 ? "current-page" : ""
                        }`}
                >
                    {crumb.link && index !== crumbs.length - 1 ? (
                        <Link to={crumb.link}>{crumb.label}</Link>
                    ) : (
                        <span>{crumb.label}</span>
                    )}
                    {index < crumbs.length - 1 &&  <span className="separator"> &gt; </span>}
                </span>
            ))}
        </nav>
    )
}

export default Breadcrumb